<template>
    <dropzone url="/system-settings/motorstats/upload"
              :success-event="successEvent"
              :fail-event="failEvent"
              v-if="! jobMonitor"
    ></dropzone>
    <div v-else>
        <h2>Data Import in Progress</h2>
        <div class="ProgressBar">
            <div class="ProgressBar__status">Status: {{ jobMonitor.message }}</div>
            <div class="ProgressBar__bar">
                <div :class="progressBarClasses" :style="progress"></div>
            </div>
            <div class="ProgressBar__count">Completed {{ jobMonitor.completed }} of {{ jobMonitor.tasks }} tasks.</div>
        </div>

        <div v-if="monitorHasData">
            <h2>Import Conflicts</h2>
            <table class="Table Table--borderless Table--min-width">
                <tr v-if="jobMonitor.data.unknown_body_types">
                    <th class="Table__cell--min-width">Unknown Body Types</th>
                    <td class="Table__cell--number Table__cell--min-width">
                        {{ jobMonitor.data.unknown_body_types }}
                    </td>
                </tr>
                <tr v-if="jobMonitor.data.unknown_colours">
                    <th class="Table__cell--min-width">Unknown Colours</th>
                    <td class="Table__cell--number Table__cell--min-width">
                        {{ jobMonitor.data.unknown_colours }}
                    </td>
                </tr>
                <tr v-if="jobMonitor.data.unknown_counties">
                    <th class="Table__cell--min-width">Unknown Counties</th>
                    <td class="Table__cell--number Table__cell--min-width">
                        {{ jobMonitor.data.unknown_counties }}
                    </td>
                </tr>
                <tr v-if="jobMonitor.data.unknown_engine_types">
                    <th class="Table__cell--min-width">Unknown Engine Types</th>
                    <td class="Table__cell--number Table__cell--min-width">
                        {{ jobMonitor.data.unknown_engine_types }}
                    </td>
                </tr>
                <tr v-if="jobMonitor.data.unknown_makes">
                    <th class="Table__cell--min-width">Unknown Makes</th>
                    <td class="Table__cell--number Table__cell--min-width">
                        {{ jobMonitor.data.unknown_makes }}
                    </td>
                </tr>
                <tr v-if="jobMonitor.data.unknown_segments">
                    <th class="Table__cell--min-width">Unknown Segments</th>
                    <td class="Table__cell--number Table__cell--min-width">
                        {{ jobMonitor.data.unknown_segments }}
                    </td>
                </tr>
                <tr v-if="jobMonitor.data.unknown_transmissions">
                    <th class="Table__cell--min-width">Unknown Transmissions</th>
                    <td class="Table__cell--number Table__cell--min-width">
                        {{ jobMonitor.data.unknown_transmissions }}
                    </td>
                </tr>
            </table>
        </div>

        <a href="#" class="Button" @click.prevent="resetForm" v-show="finished">Upload Another File</a>
    </div>
</template>

<script>
    import FileUploader from './../mixins/fileUploader';

    export default {
        mixins: [FileUploader],
    }
</script>